import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HistoryIcon from '@mui/icons-material/History';
import IosShareIcon from '@mui/icons-material/IosShare';
import {
  Card,
  CardContent,
  CardHeader,
  ClickAwayListener,
  Divider,
  Grid,
  Grow,
  MenuItem,
  MenuList,
  Modal,
  Paper,
  Popper,
  TableContainer,
} from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import PlusIcon from '@untitled-ui/icons-react/build/esm/Plus';
import UploadIcon from '@untitled-ui/icons-react/build/esm/Upload01';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { DropzoneArea } from 'react-mui-dropzone';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import LoaderIcon from 'src/components/LoaderImg/loader.gif';
import { MultiSelect } from 'src/components/multi-select';
import { Scrollbar } from 'src/components/scrollbar';
import { Seo } from 'src/components/seo';
import { useSettings } from 'src/hooks/use-settings';
import useEffectAfterMount from 'src/layouts/components/useEffectAfterMount';
import emptyImg from 'src/pages/therapist-dashboard/therapist-document/image-removebg-preview.png';
import { paths, permissions } from 'src/paths';
import { getAllSubmittedDocumentReset } from 'src/redux/actions/documentationAction';
import {
  getAllPatientsListAction,
  getAllPatientsListResetAction,
  getDownloadCSVPatientTemplate,
  getEnterprisePayerPlanType,
  getExportPatientTemplate,
  getPatientActiveInActiveCount,
  getPatientIdAction,
  getRecentUploadHistoryPatients,
  getValidationCSVTemplate,
  persistPatientIdAction,
  persistPatientListCriteria,
  resetExportPatientTemplate,
  resetValidationCSVTemplate,
} from 'src/redux/actions/patientAction';
import Search from 'src/sections/dashboard/patients/patient-listing-search';
import ListingTable from 'src/sections/dashboard/patients/patient-listing-table';
import SimpleSnackbar from './details-page/sub-components/snackBar';

const { CREATE_PATIENT, READ_EPISODE_OF_CARE } = permissions;
interface SearchChip {
  label: string;
  field: 'Status' | 'Payer Type';
  value: unknown;
  displayValue?: unknown;
}

interface Option {
  label: string;
  value: string;
}

const statusOptions: Option[] = [
  {
    label: 'Active',
    value: 'active',
  },
  {
    label: 'Inactive',
    value: 'inactive',
  },
];

const Patients = () => {
  const settings = useSettings();
  const [rowPerPage, setRowPerPage] = useState(20);
  const [page, setPage] = useState(0);
  const [chips, setChips] = useState<SearchChip[]>([
    {
      field: 'Status',
      label: 'Status',
      value: 'active',
    },
  ]);

  const [payerChips, setPayerChips] = useState<SearchChip[]>([]);
  const permissionData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.currentPermissions
  );

  const getAllPatientRes = useSelector((state: any) => state.getAllPatientListReducer);

  const [searchData, setSearchData] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { patients, patientDetails, createPatient, episodeOfCare } = paths;
  const [popUpContent, setPopup] = useState(false);
  const [uploadCsvModal, setUploadCsvModal] = useState(false);
  const anchorRef = useRef<any>(null);
  const [fileUploaded, setFileUploaded] = useState<any>();
  const getPayerPlanTypeResponse = useSelector(
    (state: any) => state.getPayerPlanTypeReducer?.enterprisePayerPlanType?.data
  );
  const facilityId = localStorage.getItem('facilityId');

  const getPatientCount = useSelector(
    (state: any) => state.getPatientActiveInActiveCountReducer?.response
  );
  const getDownloadCSVResponse = useSelector(
    (state: any) => state.getDownloadCSVTemplateReducer?.response
  );
  const getPatientExportCsvRespose = useSelector((state: any) => state.getPatientExportCsvReducer);
  const [patientError, setPatientError] = useState('');

  const [selectedPayerPlanValues, setSelectedPayerPlanValues] = useState<string[]>([]);
  useEffect(() => {
    dispatch(getEnterprisePayerPlanType());
    dispatch(
      getPatientActiveInActiveCount({
        facilityId: facilityId,
      })
    );
    dispatch(resetValidationCSVTemplate());
  }, []);

  useEffect(() => {
    if (!getPatientExportCsvRespose.isExportSuccess && getPatientExportCsvRespose.response === null)
      return;
    if (
      !getPatientExportCsvRespose.isExportSuccess &&
      getPatientExportCsvRespose.response !== null
    ) {
      setPatientError(getPatientExportCsvRespose?.response?.message);
      return;
    }
    if (getPatientExportCsvRespose?.isExportSuccess) {
      setPatientError('');
      downloadFile(getPatientExportCsvRespose?.response?.data);
    }
    setTimeout(() => {
      dispatch(resetExportPatientTemplate());
    }, 3000);
    return;
  }, [getPatientExportCsvRespose]);

  const getAllPatientApiCall = (page: any) => {
    dispatch(
      getAllPatientsListAction({
        data: {
          searchString: searchData?.trim()?.split('-')?.join(''),
        },
        params: {
          page,
          pageSize: 20,
          active: chips[0]?.value === 'active' ? true : chips[0]?.value === 'inactive' ? false : '',
          payerType: selectedPayerPlanValues.length > 0 ? selectedPayerPlanValues[0] : '',
        },
      })
    );
  };

  useEffect(() => {
    if (getAllPatientRes?.totalPatient?.length && !getAllPatientRes?.searchName) {
      return;
    }
    dispatch(getAllPatientsListResetAction());
    getAllPatientApiCall(0);
  }, []);

  useEffectAfterMount(() => {
    dispatch(getAllPatientsListResetAction());
    getAllPatientApiCall(0);
  }, [chips, searchData, selectedPayerPlanValues]);

  const onPageChange = (event: any, newPage: number) => {
    setPage(newPage);
  };
  const onRowsPerPageChange = (event: any) => {
    const newRowsPerPage = event.target.value;
    setRowPerPage(newRowsPerPage);
    setPage(0);
  };

  const onRowClick = (data: any) => {
    if (!permissionData?.includes(READ_EPISODE_OF_CARE)) {
      return;
    }
    dispatch(persistPatientIdAction(data?.uuid));
    dispatch(
      persistPatientListCriteria({
        searchName: searchData,
        payerType: '',
        status: '',
      })
    );
    dispatch(getAllSubmittedDocumentReset());
    dispatch(getPatientIdAction(data?.uuid));
    navigate(`${patients}/${patientDetails}${episodeOfCare}`);
  };

  const handleAddPatientPopUp = useCallback((): void => {
    setPopup((prevOpen) => !prevOpen);
  }, []);

  function addNewPatient() {
    navigate(`${patients}/${createPatient}`);
  }

  const handleUploadCsvModal = () => {
    setUploadCsvModal(true);
  };
  const handleCloseUploadCsvModal = () => {
    setUploadCsvModal(false);
  };

  const handleStatusChange = useCallback((values: string[]): void => {
    setChips((prevChips) => {
      const valuesFound: string[] = [];

      const newChips = prevChips.filter((chip) => {
        if (chip.field !== 'Status') {
          return true;
        }

        const found = values.includes(chip.value as string);

        if (found) {
          valuesFound.push(chip.value as string);
        }

        return found;
      });

      if (values.length === valuesFound.length) {
        return newChips;
      }

      values.forEach((value) => {
        if (!valuesFound.includes(value)) {
          const option = statusOptions?.find((option) => option.value === value);

          newChips.push({
            label: 'Status',
            field: 'Status',
            value: value,
          });
        }
      });

      return newChips;
    });
  }, []);

  const statusValues = useMemo(
    () => chips.filter((chip) => chip.field === 'Status').map((chip) => chip.value) as string[],
    [chips]
  );

  const payerPlanOptions = useMemo(() => {
    return getPayerPlanTypeResponse?.map((option: any) => ({
      label: option?.displayName,
      value: option?.key,
    }));
  }, [getPayerPlanTypeResponse]);

  const handleClose = useCallback((event: Event): void => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }
    setPopup(false);
  }, []);

  const handleDownloadCSVTemplate = () => {
    dispatch(getDownloadCSVPatientTemplate());
    downloadFile(getDownloadCSVResponse);
  };

  const downloadFile = (response: any) => {
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'patient-template.csv');
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const handleUploadValidationTemplate = () => {
    const formData = new FormData();

    formData.append('file', fileUploaded[0]);

    dispatch(getValidationCSVTemplate(formData));
    navigate(`${patients}/upload`);
  };

  const handleRecentUpdate = () => {
    dispatch(getRecentUploadHistoryPatients());
    navigate(`${patients}/recent-uploaded`);
  };
  const handleExportFile = () => {
    dispatch(
      getExportPatientTemplate({
        searchString: '',
      })
    );

    handleClose;
  };

  return (
    <>
      <Seo title="Restore-Insights: Patient" />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 8,
        }}
      >
        <Container maxWidth={settings.stretch ? false : 'xl'}>
          <Stack
            spacing={{
              xs: 3,
              lg: 4,
            }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={4}
            >
              <Stack gap="1rem">
                <Typography variant="h4">Patients</Typography>
                <Stack
                  gap="1rem"
                  flexDirection="row"
                >
                  <Stack
                    flexDirection="row"
                    sx={{
                      borderRadius: '12px',
                      display: 'flex',
                      border: '1px solid #00000042',
                      color: '#111927',
                      padding: '3px 10px',
                    }}
                  >
                    {getPatientCount?.allCount <= 1
                      ? `${getPatientCount?.allCount} Patient`
                      : `${getPatientCount?.allCount} Patients`}
                  </Stack>

                  <Stack
                    flexDirection="row"
                    sx={{
                      borderRadius: '12px',
                      display: 'flex',
                      border: '1px solid #15B79E80',

                      color: '#15B79E',
                      padding: '3px 10px',
                      opacity: '.7',
                    }}
                  >
                    {getPatientCount?.activeCount ? getPatientCount?.activeCount : '0'} Active
                  </Stack>
                  <Stack
                    flexDirection="row"
                    sx={{
                      borderRadius: '12px',
                      display: 'flex',
                      border: '1px solid #F7900980',
                      color: '#F79009',
                      padding: '3px 10px',
                    }}
                  >
                    {getPatientCount?.deActiveCount ? getPatientCount?.deActiveCount : '0'} Inactive
                  </Stack>
                </Stack>
              </Stack>

              <Stack
                direction="row"
                spacing={4}
              >
                <Button
                  startIcon={
                    <SvgIcon>
                      <PlusIcon />
                    </SvgIcon>
                  }
                  endIcon={
                    <SvgIcon>
                      <ExpandMoreIcon />
                    </SvgIcon>
                  }
                  // sx={{ position: 'absolute', right: 0 }}
                  variant="contained"
                  disabled={!permissionData?.includes(CREATE_PATIENT)}
                  onClick={handleAddPatientPopUp}
                  ref={anchorRef}
                >
                  Add New Patient
                </Button>
                <Popper
                  anchorEl={anchorRef.current}
                  open={popUpContent}
                  transition
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                        boxShadow: '0px 3px 14px 0px rgba(0, 0, 0, 0.08)',
                        borderRadius: '12px',
                        background: '#fff',
                        // width: 'auto',
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleClose}>
                          <MenuList>
                            <MenuItem onClick={addNewPatient}>
                              <Grid container>
                                <Grid item>
                                  <SvgIcon>
                                    <PlusIcon />
                                  </SvgIcon>
                                </Grid>
                                <Grid item>Add New Patient</Grid>
                              </Grid>
                            </MenuItem>

                            <MenuItem onClick={handleUploadCsvModal}>
                              <Grid container>
                                <Grid
                                  item
                                  marginRight={0.5}
                                >
                                  <SvgIcon>
                                    <UploadIcon />
                                  </SvgIcon>
                                </Grid>
                                <Grid item>Upload CSV File</Grid>
                              </Grid>
                            </MenuItem>
                            <MenuItem onClick={handleRecentUpdate}>
                              <Grid container>
                                <Grid
                                  item
                                  marginRight={0.5}
                                >
                                  <SvgIcon>
                                    <HistoryIcon />
                                  </SvgIcon>
                                </Grid>
                                <Grid item>View Uploads History</Grid>
                              </Grid>
                            </MenuItem>
                            <MenuItem onClick={handleExportFile}>
                              <Grid container>
                                <Grid
                                  item
                                  marginRight={0.5}
                                >
                                  <SvgIcon>
                                    <IosShareIcon />
                                  </SvgIcon>
                                </Grid>
                                <Grid item>Download Patients List</Grid>
                              </Grid>
                            </MenuItem>
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </Stack>
            </Stack>
            <Card sx={{ padding: '2rem' }}>
              <Stack
                gap="1rem"
                sx={{ padding: '0 1rem 1rem 1rem' }}
                flexDirection="row"
              >
                <MultiSelect
                  label="Status"
                  onChange={handleStatusChange}
                  options={statusOptions}
                  value={statusValues}
                  isMulti={false}
                />
                <MultiSelect
                  label="Payer Type"
                  isMulti={false}
                  options={payerPlanOptions || []}
                  value={selectedPayerPlanValues}
                  onChange={(values: string[]) => {
                    setSelectedPayerPlanValues(values);
                    const selectedKeys = values?.map((value) => {
                      return value;
                    });
                  }}
                />
              </Stack>
              <Scrollbar>
                <Stack gap="1rem">
                  <Search
                    setSearchData={setSearchData}
                    searchData={searchData}
                    setPage={setPage}
                    placeholder="Search by patient name, medical record no, social security number, etc."
                  />
                  <TableContainer
                    component={Paper}
                    sx={{ height: 700 }}
                  >
                    <InfiniteScroll
                      dataLength={getAllPatientRes?.totalPatient?.length}
                      next={() => {
                        getAllPatientApiCall(getAllPatientRes?.pageNumber);
                      }}
                      style={{
                        overflow: 'scroll',
                        height: 700,
                      }}
                      height={800}
                      hasMore={
                        getAllPatientRes?.response?.data?.totalElements !==
                        getAllPatientRes?.totalPatient?.length
                      }
                      loader={
                        getAllPatientRes?.loading ? (
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: 250,
                              width: '100%',
                              // marginTop: ,
                            }}
                          >
                            <img
                              src={LoaderIcon}
                              alt="loader.."
                            />
                          </div>
                        ) : !getAllPatientRes?.isGetPatients &&
                          getAllPatientRes?.response !== null ? (
                          <Box>
                            <img
                              src={emptyImg}
                              alt="loader"
                              style={{
                                width: 720,
                                height: 300,
                                margin: 'auto',
                                alignItems: 'center',
                                alignContent: 'center',
                                marginTop: 100,
                                display: 'block',
                              }}
                            />

                            <Typography
                              color={'text.secondary'}
                              variant="h5"
                              fontWeight={'200'}
                              sx={{
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            >
                              Something went's wrong
                            </Typography>
                          </Box>
                        ) : null
                      }
                      endMessage={
                        <Box
                          textAlign="center"
                          p={3}
                        >
                          {getAllPatientRes?.totalPatient?.length === 0 ? (
                            <Box>
                              <img
                                src={emptyImg}
                                alt="loader"
                                style={{
                                  width: 720,
                                  height: 300,
                                  margin: 'auto',
                                  alignItems: 'center',
                                  alignContent: 'center',
                                  marginTop: 100,
                                  display: 'block',
                                }}
                              />

                              <Typography
                                color={'text.secondary'}
                                variant="h5"
                                fontWeight={'200'}
                              >
                                No results found
                              </Typography>
                            </Box>
                          ) : null}
                        </Box>
                      }
                    >
                      <ListingTable
                        items={getAllPatientRes?.totalPatient}
                        onRowClick={onRowClick}
                      />
                    </InfiniteScroll>
                  </TableContainer>
                </Stack>
              </Scrollbar>
            </Card>
          </Stack>
        </Container>
      </Box>
      <Modal
        open={uploadCsvModal}
        onClose={handleCloseUploadCsvModal}
        sx={{ p: 0 }}
      >
        <Card
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '55%',
            borderRadius: '8px',
            padding: '16px',
            maxHeight: '90%',
          }}
        >
          <CardHeader
            title="Upload Patients"
            sx={{
              padding: '16px',
              '& .MuiTypography-root': {
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 700,
                fontSize: '1.5rem',
                lineHeight: 1.2,
              },
            }}
          />
          <Divider />
          <CardContent sx={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
            <DropzoneArea
              filesLimit={1}
              onChange={(files: any) => setFileUploaded(files)}
              dropzoneText={
                <div>
                  <p>Drag & Drop or Click To Browse</p>
                  <Button>Browse</Button>
                </div>
              }
              showFileNames={true}
              Icon={(props: any) => null}
            />
            <Stack>
              <Button onClick={handleDownloadCSVTemplate}>
                <Typography
                  variant="h6"
                  color="#6366F1"
                  textAlign="center"
                >
                  Download Patients CSV Template
                </Typography>
              </Button>
            </Stack>
            <Stack>
              <Typography
                variant="h6"
                textAlign="center"
              >
                Enter patient information into the template, then re-upload the file.
              </Typography>
            </Stack>
            <Stack>
              <Typography
                variant="h6"
                textAlign="center"
              >
                Maximum upload file size: 10 MB.
              </Typography>
            </Stack>
          </CardContent>
          <Stack
            flexDirection="row"
            gap="1rem"
            justifyContent="flex-end"
            sx={{ marginTop: '1rem' }}
          >
            <Button
              color="inherit"
              onClick={handleCloseUploadCsvModal}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleUploadValidationTemplate}
            >
              Upload
            </Button>
          </Stack>
        </Card>
      </Modal>
      {getPatientExportCsvRespose?.isExportSuccess === true && (
        <SimpleSnackbar
          message="File Exported Successfully"
          isError={!getPatientExportCsvRespose?.isExportSuccess}
        />
      )}
    </>
  );
};

export default Patients;
